import get from "lodash/get";
import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import classNames from "classnames";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import Select from "react-select";
import CreateComp from "../create";
import biodata from "../../../../Assets/Svg/biodata.svg";
// import { ValidateAction } from './../../../../Utils/Validation'
import { instance } from "../../../../Actions/AxiosInstance";
import {
  ValidateAction,
  ValidateList,
  ValidateReqField,
  ValidateSearchDropdown,
} from "../../../../Utils/Validation";
import createstore from "../../../../store";
import If from "../../../../Component/Common/If";

const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
});

class EmpPersonal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        partnername: "",
        genderpronoun: "",
        challenged: "",
      },
      isEdit: this.props.editmode,
      reqFields: {},
      list: {
        bloodgroupid: "",
        maritalstatusid: "",
        genderid: "",
      },
      reqList: {
        genderid: "",
      },
      errors: {},
      helperText: {},
      genderList: [],
      bloodGroupList: [],
      maritalStatusList: [],
      placeholder: "text",
      hideButton: false,
      data: {},
      viewpage: true,
      dataReceived: false,
      firsttime: false,
      edit: false,
    };

    this.onCancel = this.onCancel.bind(this);
  }

  componentDidMount() {
    // setTimeout(() => {
    //     this.GetPersonalDetails();
    // }, 500)
    if (this.firstElement) this.firstElement.focus();
  }

  componentWillMount() {
    // CustomForm();
    // this.props.ChangeLanguage("");/config/payroll/IT_declaration
    this.GetGender();
    this.GetBloodGroup();
    this.GetMaritalStatus();
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    let employeeid;
    employeeid = SubscriptionInfo.SubscriptionData.employeeid;

    const { AuthenticationAction } = createstore.getState();
    if (AuthenticationAction.IsFulfilled) {
      employeeid = AuthenticationAction.login.employeeid;
    }
    const { colleagueid } = this.props.match.params;

    const masterprofileid = get(
      AuthenticationAction,
      "login.masterprofileid",
      9,
    );
    const { permissions } = this.props;
    let hideButton;
    permissions.editable
      ? colleagueid && colleagueid != employeeid
        ? masterprofileid != 9
          ? (hideButton = true)
          : (hideButton = false)
        : (hideButton = false)
      : masterprofileid != 9
      ? (hideButton = true)
      : (hideButton = false);
    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
        colleagueid,
        hideButton,
      },
      () => {
        this.GetPersonalDetails();
      },
    );
  }

  UpdateSelectedDropdownItem(name, selectedName, selectedItem) {
    const { list } = this.state;
    const { reqList } = this.state;
    // list[name] = selectedItem;
    list[name] = selectedItem.displayvalue ? selectedItem.displayvalue : "";
    // [selectedName] = selectedItem ? selectedItem : ''
    this.setState({ list, [selectedName]: selectedItem });

    if (reqList[name] == "" || reqList[name] || reqList[name] == null) {
      reqList[name] = selectedItem.displayvalue
        ? selectedItem.displayvalue
        : "";
      this.setState({ reqList });
      // ValidateDropdown(this.state, name)
      this.setState({ reqList }, () => {
        this.ValidateEachDropDown(name);
      });
    }
    if (name == "maritalstatusid") {
      const fields = {
        partnername: "",
        genderpronoun: this.state.fields.genderpronoun,
        challenged: this.state.fields.challenged,
      };
      this.setState({ fields });
    }
  }

  ValidateEachDropDown(name) {
    ValidateSearchDropdown(this.state, name).then((result) => {
      this.setState({
        errors: result.errors,
      });
    });
  }

  OnFieldChange(field, type, e) {
    const { fields } = this.state;
    const { errors } = this.state;
    fields[field] = e.target.value ? e.target.value : "";
    this.setState({ fields, errors }, () => {
      ValidateAction(this.state, field, type);
    });
  }

  ValidateOnNext(reqField, type) {
    if (ValidateAction(this.state, reqField, type)) {
      ValidateReqField(this.state, reqField, type);
    }
  }

  GetGender() {
    instance
      .get("superuser/getgender")
      .then((result) => {
        const genderList = [];
        genderList.push(
          { displayname: "Select Gender", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ genderList });
        if (this.state.list.genderid) {
          const selectedGender = this.state.genderList.find(
            (x) => x.displayvalue == this.state.list.genderid,
          );
          this.setState({ selectedGender });
        }
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetBloodGroup() {
    instance
      .get("superuser/getmastercode/BloodGroupType")
      .then((result) => {
        const bloodGroupList = [];
        bloodGroupList.push(
          { displayname: "Select Blood Group", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ bloodGroupList });
        if (this.state.list.bloodgroupid) {
          const selectedBloodGroup = this.state.bloodGroupList.find(
            (x) => x.displayvalue == this.state.list.bloodgroupid,
          );
          this.setState({ selectedBloodGroup });
        }
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetMaritalStatus() {
    instance
      .get("superuser/getmastercode/MaritalStatus")
      .then((result) => {
        const maritalStatusList = [];
        maritalStatusList.push(
          { displayname: "Select Marital Status", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ maritalStatusList });
        if (this.state.list.maritalstatusid) {
          const selectedMaritalStatus = this.state.maritalStatusList.find(
            (x) => x.displayvalue == this.state.list.maritalstatusid,
          );
          this.setState({ selectedMaritalStatus });
        }
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetPersonalDetails() {
    const URL = "employee/getempallpersonal";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        data = {
          employeeid: this.state.colleagueid,
          accountid: this.state.accountid,
          subscriptionid: this.state.subscriptionid,
          timezoneid: this.state.countrytimezoneid,
        };
      } else {
        data = {};
      }
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.props.colleagueid || this.state.employeeid,
      };
    }
    instance
      .post(URL, data)
      .then((result) => {
        let data = {};
        result.data.result.length > 0
          ? (data = result.data.result[0])
          : (data = {});

        // let employeeid = data.employeeid;
        const fields = {
          partnername: data.partnername ? data.partnername : "",
          genderpronoun: data.genderpronoun,
          challenged: data.challenged,
        };
        const reqFields = {};
        const list = {
          genderid: data.genderid,
          bloodgroupid: data.bloodgroupid,
          maritalstatusid: data.maritalstatusid,
        };
        const reqList = {
          genderid: data.genderid,
        };
        const selectedGender = this.state.genderList.find(
          (x) => x.displayvalue == list.genderid,
        );
        const selectedBloodGroup = this.state.bloodGroupList.find(
          (x) => x.displayvalue == list.bloodgroupid,
        );
        const selectedMaritalStatus = this.state.maritalStatusList.find(
          (x) => x.displayvalue == list.maritalstatusid,
        );

        this.setState({
          fields,
          reqFields,
          list,
          reqList,
          selectedGender,
          selectedBloodGroup,
          selectedMaritalStatus,
          data,
          dataReceived: true,
        });
        if (this.state.data) {
          this.setState({
            firsttime: this.state.data.gendername != null ? false : true,
          });
        }
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getEditMode() {
    this.setState(
      {
        viewpage: false,
        firsttime: false,
      },
      () => {
        setTimeout(() => {
          if (this.firstElement) this.firstElement.focus();
        }, 500);
      },
    );
  }

  Validate() {
    let formIsValid = true;

    if (!ValidateList(this.state)) {
      formIsValid = false;
    }
    return formIsValid;
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
  }

  onCancel() {
    const { data } = this.state;
    this.setState({
      viewpage: true,
    });
    if (data.gendername == "" || data.gendername == null) {
      this.setState({ firsttime: true });
    }
  }

  UpdatePersonalDetails() {
    if (!this.state.list.genderid) {
      this.props.enqueueSnackbar("Please Select Gender", { variant: "error" });
    } else {
      const data = {
        // "employeeid":this.state.employeeid,
        genderid: this.state.list.genderid,
        bloodgroupid: this.state.list.bloodgroupid,
        maritalstatusid: this.state.list.maritalstatusid,
        genderpronoun: this.state.fields.genderpronoun,
        partnername: this.state.fields.partnername,
        challenged: this.state.fields.challenged,
        employeeid: this.props.colleagueid || this.state.employeeid,
      };
      if (!createstore.getState().AuthenticationAction.IsFulfilled) {
        Object.assign(data, {
          accountid: this.state.accountid,
          subscriptionid: this.state.subscriptionid,
          timezoneid: this.state.countrytimezoneid,
          employeeid: this.props.colleagueid || this.state.employeeid,
        });
      }

      instance
        .post("employee/insertupdateemppersonal", data)
        .then((result) => {
          this.props.enqueueSnackbar("Saved successfully", {
            variant: "success",
          });
          this.props.UpdateStrength(true);
          this.GetPersonalDetails();
          this.setState({
            viewpage: true,
          });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  showComp = (value) => <div className="address-data">{value || "-"}</div>;

  render() {
    const { data, dataReceived, viewpage, hideButton, firsttime } = this.state;
    const { classes } = this.props;
    return (
      <div>
        <If condition={dataReceived}>
          <If condition={firsttime == true}>
            <CreateComp
              text="A little about the you "
              heading={
                <FormattedMessage
                  id="LbPersonalDetails"
                  defaultMessage="Bio Data"
                />
              }
              onCreate={this.getEditMode.bind(this)}
              imageSrc={biodata}
            />
          </If>
          <If condition={firsttime == false}>
            <div>
              <svg
                className={
                  !viewpage || hideButton ? "hide-button" : "biodata-edit-btn"
                }
                onClick={this.getEditMode.bind(this)}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                style={{ zIndex: 10 }}
              >
                <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z" />
              </svg>
              <div className="emp-from-wrapper imp-dates">
                <div id="div">
                  <form
                    className="custom-form-box profile-personal"
                    autoComplete="off"
                  >
                    <div className="inner-wrapper opaque" tabIndex="0">
                      <div className="form-group">
                        <p className="input-form-label">
                          <span className="emp-special-head">
                            <FormattedMessage
                              id="LbGender"
                              defaultMessage="Gender"
                            />
                          </span>
                        </p>
                        {viewpage ? (
                          this.showComp(data.gendername)
                        ) : (
                          <div>
                            <Select
                              ref={(r) => {
                                this.firstElement = r;
                              }}
                              className="selectsearch"
                              onChange={this.UpdateSelectedDropdownItem.bind(
                                this,
                                "genderid",
                                "selectedGender",
                              )}
                              options={this.state.genderList}
                              getOptionLabel={(option) => option.displayname}
                              getOptionValue={(option) => option.displayvalue}
                              value={this.state.selectedGender}
                              placeholder="Gender"
                            />
                            <div>
                              {this.state.errors.genderid ? (
                                <span className="caption-error">
                                  {" "}
                                  <FormattedMessage
                                    id="Erchallenged"
                                    defaultMessage="can not be empty"
                                  />
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="inner-wrapper opaque" tabIndex="1">
                      <div className="form-group">
                        <p className="input-form-label">
                          <span className="emp-special-head">
                            <FormattedMessage
                              id="LbBloodGroup"
                              defaultMessage="Blood Group"
                            />
                            <FormattedMessage
                              id="LbOptional"
                              defaultMessage="(Optional)"
                            />
                          </span>
                        </p>
                        {viewpage ? (
                          this.showComp(data.bloodgroupname)
                        ) : (
                          <div>
                            <Select
                              className="selectsearch"
                              onChange={this.UpdateSelectedDropdownItem.bind(
                                this,
                                "bloodgroupid",
                                "selectedBloodGroup",
                              )}
                              options={this.state.bloodGroupList}
                              getOptionLabel={(option) => option.displayname}
                              getOptionValue={(option) => option.displayvalue}
                              value={this.state.selectedBloodGroup}
                              placeholder="Blood Group"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="inner-wrapper opaque" tabIndex="2">
                      <div className="form-group">
                        <p className="input-form-label">
                          <FormattedMessage
                            id="Lbgenderpronoun"
                            defaultMessage="Gender pronoun"
                          />{" "}
                          <FormattedMessage
                            id="LbOptional"
                            defaultMessage="(Optional)"
                          />{" "}
                        </p>
                        {viewpage ? (
                          this.showComp(data.genderpronoun)
                        ) : (
                          <div>
                            <TextField
                              id="genderpronoun"
                              className={classNames(
                                classes.textField,
                                classes.dense,
                              )}
                              variant="outlined"
                              onChange={this.OnFieldChange.bind(
                                this,
                                "genderpronoun",
                                "text",
                              )}
                              value={this.state.fields.genderpronoun}
                              inputProps={{ maxLength: 15 }}
                            />
                            <div>
                              {this.state.errors.genderpronoun ? (
                                <span className="caption-error">
                                  {" "}
                                  <FormattedMessage
                                    id="Ergenderpronoun"
                                    defaultMessage="can not be empty"
                                  />
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="inner-wrapper opaque" tabIndex="3">
                      <div className="form-group">
                        <p className="input-form-label">
                          Challenged
                          <FormattedMessage
                            id="LbOptional"
                            defaultMessage="(Optional)"
                          />{" "}
                        </p>
                        {viewpage ? (
                          this.showComp(data.challenged)
                        ) : (
                          <div>
                            <TextField
                              id="challenged"
                              className={classNames(
                                classes.textField,
                                classes.dense,
                              )}
                              margin="dense"
                              variant="outlined"
                              value={this.state.fields.challenged}
                              onChange={this.OnFieldChange.bind(
                                this,
                                "challenged",
                                "text",
                              )}
                            />
                            <div>
                              {this.state.errors.challenged ? (
                                <span className="caption-error">
                                  {" "}
                                  <FormattedMessage
                                    id="Erchallenged"
                                    defaultMessage="can not be empty"
                                  />
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="inner-wrapper opaque" tabIndex="4">
                      <div className="form-group" tabIndex="4">
                        <p className="input-form-label">
                          <span className="emp-special-head">
                            <FormattedMessage
                              id=" LbMaritalStatus"
                              defaultMessage="Marital status"
                            />{" "}
                            (Optional)
                          </span>
                        </p>
                        {viewpage ? (
                          this.showComp(data.maritalstatusname)
                        ) : (
                          <div>
                            <Select
                              className="selectsearch"
                              onChange={this.UpdateSelectedDropdownItem.bind(
                                this,
                                "maritalstatusid",
                                "selectedMaritalStatus",
                              )}
                              options={this.state.maritalStatusList}
                              getOptionLabel={(option) => option.displayname}
                              getOptionValue={(option) => option.displayvalue}
                              value={this.state.selectedMaritalStatus}
                              placeholder="Marital Status"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="inner-wrapper opaque" tabIndex="5">
                      <div className="form-group">
                        <p className="input-form-label">
                          <span className="emp-special-head">
                            <FormattedMessage
                              id="LbPartnerName"
                              defaultMessage="Your spouse/partner's name"
                            />
                          </span>{" "}
                          <FormattedMessage
                            id="LbOptional"
                            defaultMessage="(Optional)"
                          />
                        </p>
                        {viewpage ? (
                          this.showComp(data.partnername)
                        ) : (
                          <div>
                            {this.state.list.maritalstatusid == 2 ? (
                              <TextField
                                id="partnername"
                                className={`${classNames(
                                  classes.textField,
                                  classes.dense,
                                )} form-control input-area-section`}
                                margin="dense"
                                onChange={this.OnFieldChange.bind(
                                  this,
                                  "partnername",
                                  "name",
                                )}
                                value={this.state.fields.partnername}
                                variant="outlined"
                                maxLength="100"
                              />
                            ) : (
                              <TextField
                                id="outlined-dense partnername"
                                value={this.state.fields.partnername}
                                className={`${classNames(
                                  classes.textField,
                                  classes.dense,
                                )} form-control input-area-section`}
                                margin="dense"
                                variant="outlined"
                                maxLength="100"
                                onChange={this.OnFieldChange.bind(
                                  this,
                                  "partnername",
                                  "name",
                                )}
                              />
                            )}
                            <div>
                              {this.state.errors.partnername ? (
                                <span className="caption-error">
                                  {" "}
                                  <FormattedMessage
                                    id="ErPartnerName"
                                    defaultMessage="can not be empty"
                                  />
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    {!viewpage && (
                      <div className="upform-footer">
                        <Button
                          className="form-btn form-control"
                          variant="contained"
                          color="primary"
                          size="large"
                          onClick={this.UpdatePersonalDetails.bind(this)}
                        >
                          <FormattedMessage id="BtSave" defaultMessage="Save" />
                        </Button>
                        <span className="margin-left-16">
                          <Button
                            className="margin-left-16"
                            size="large"
                            onClick={this.onCancel}
                          >
                            <FormattedMessage
                              id="BtCancel"
                              defaultMessage="Cancel"
                            />
                          </Button>
                        </span>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </If>
        </If>
      </div>
    );
  }
}

EmpPersonal.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withSnackbar(EmpPersonal));
